import React, { type ReactNode } from 'react';
import type { AuthUser } from '../services/auth';

interface TotpEnforcerProps {
  user: AuthUser;
  children: ReactNode;
}

/**
 * Wraps authenticated routes. TOTP/MFA is enforced during sign-in (Login flow).
 * Once the user is authenticated, they have already completed MFA when required.
 * This component simply renders children.
 */
export const TotpEnforcer: React.FC<TotpEnforcerProps> = ({ user: _user, children }) => {
  return <>{children}</>;
};
